export default "__VITE_ASSET__2TtU6R81__"